import { createAction } from '@reduxjs/toolkit';

export const resetTimelineDates = createAction('RESET_TIMELINE_DATES');
export const showFutureDates = createAction('SHOW_FUTURE_DATES');
export const showPastDates = createAction('SHOW_PAST_DATES');
